import { render, staticRenderFns } from "./snippletTabellaDate.vue?vue&type=template&id=29d749f0&scoped=true"
import script from "./snippletTabellaDate.vue?vue&type=script&lang=js"
export * from "./snippletTabellaDate.vue?vue&type=script&lang=js"
import style0 from "./snippletTabellaDate.vue?vue&type=style&index=0&id=29d749f0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d749f0",
  null
  
)

export default component.exports